export enum IntelligenceAccountProgressStatus {
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger'
}

export interface IntelligenceAccount {
  id: string;
  name: string;
  revenueGoal: number;
  currentRevenueYTD: number;
  pitchValue: {
    amount: number;
    categoriesCount: number;
  };
  winsYTD: number;
  churnedYTD: number;
}
